export default {
  getterGroupsetsSelfRegistration: state => state.groupsetsSelfRegistration
};
